import { Stack } from "@mui/material";
import { SlideToConfirmButton, Text } from "@src/appV2/redesign/system/ui-components";

import { PayoutScheduleItem } from "../../../../Accounts/PayoutSettings/components/PayoutScheduleItem";
import { Button } from "../../../../components/Button";
import { TextButton } from "../../../../components/TextButton";

export interface SuggestInstantPayBottomSheetContentProps {
  instantPayFee: number;
  isSwitchToInstantPayLoading: boolean;
  isSwitchToInstantPaySuccess: boolean;
  onSwitchToInstantPay: () => void;
  onSwitchToInstantPaySuccessShown: () => void;
  onClose: (dontAskAgain: boolean) => void;
}

export function SuggestInstantPayBottomSheetContent(
  props: SuggestInstantPayBottomSheetContentProps
) {
  const {
    instantPayFee,
    isSwitchToInstantPayLoading,
    isSwitchToInstantPaySuccess,
    onSwitchToInstantPay,
    onSwitchToInstantPaySuccessShown,
    onClose,
  } = props;

  return (
    <Stack spacing={9} sx={(theme) => ({ paddingTop: theme.spacing(8) })}>
      <Text semibold variant="h3" sx={{ textAlign: "center" }}>
        Want to get paid right after every clock out?
      </Text>
      <PayoutScheduleItem
        selected={false}
        payoutSchedule="instant"
        title="InstantPay"
        description="Clock out of your shift, and have your money in your bank account within 30 minutes."
        illustrationType="instant-pay-small"
        fee={instantPayFee}
        // We don't want to show the radio indicator
        // as there is only one option and it would be confusing
        radioIndicatorSx={{ display: "none" }}
        onSelect={() => {
          // empty
        }}
      />
      <Stack spacing={4}>
        <Text
          variant="body2"
          sx={(theme) => ({ color: theme.palette.text.secondary, textAlign: "center" })}
        >
          You are currently on Standard Payout, which means you'll receive your earnings within 1-3
          business days.
        </Text>
        <SlideToConfirmButton
          ctaText="Slide to switch to InstantPay"
          successText="Switched to InstantPay!"
          isLoading={isSwitchToInstantPayLoading}
          success={isSwitchToInstantPaySuccess}
          onConfirm={onSwitchToInstantPay}
          onSuccessShown={onSwitchToInstantPaySuccessShown}
        />
        <Button fullWidth variant="outlined" size="large" onClick={() => onClose(false)}>
          No, thanks
        </Button>
        <TextButton underline sx={{ alignSelf: "center" }} onClick={() => onClose(true)}>
          Don't show this again
        </TextButton>
      </Stack>
    </Stack>
  );
}
